"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.VideoPlayerAction=void 0;var e;(function(o){o.ProductOpen="product_open",o.SoundOff="sound_off",o.SoundOn="sound_on",o.StoreOpen="store_open"})(e||(exports.VideoPlayerAction=e={}));
//# sourceMappingURL=VideoPlayerAction.js.map
